import styled from 'styled-components';

export const StoryArticleContainer = styled.div`
  .swiper-initialized {
    overflow: visible;
  }
`;
